var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rk-topo"},[_c('TopoAside'),_c('Topo',{attrs:{"datas":{nodes:_vm.stateTopo.nodes,calls:_vm.stateTopo.calls}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }